import { render, staticRenderFns } from "./inspectionPointList.vue?vue&type=template&id=389e645d&scoped=true"
import script from "./inspectionPointList.vue?vue&type=script&lang=js"
export * from "./inspectionPointList.vue?vue&type=script&lang=js"
import style0 from "./inspectionPointList.vue?vue&type=style&index=0&id=389e645d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e645d",
  null
  
)

export default component.exports